module.exports = __webpack_public_path__ + "static/media/microbit-back.1009f24b.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/microbit-back.png
// module id = 35
// module chunks = 0